import React, {Component} from "react";
import {Col, Container, Form, Row} from "react-bootstrap";
import {DateInput} from "../../../../../components";
import DateUtil from "../../../../../utils/DateUtil";
import DirectBillingReferralTypeEnum from "../../../enums/DirectBillingReferralTypeEnum";

export default class ReferralValidityTab extends Component {
    visitDateTemplate(referral) {
        return DirectBillingReferralTypeEnum[referral.type] === DirectBillingReferralTypeEnum.INTERNAL ?
            referral.visit.appointment.startTime ? DateUtil.formatDate(referral.visit.appointment.startTime, "Do MMMM YYYY / hh:mm A") : ""
            : "N/A"
    }

    dateInputTemplate = (field) => {
        return (
            <DateInput className={"whiteBackground"}
                       value={this.props.referral[field]}
                       disabled={this.props.readOnly}
                       onChange={(value) => this.props.onReferralChange(this.props.referral.id, field, value)}/>
        )
    }

    dateTimeTemplate(data) {
        return DateUtil.formatDate(data, "Do MMMM YYYY / hh:mm A")
    }

    render() {
        return <Container>
            <Row>
                <Col>
                    <Field label={"Valid From"} body={this.dateInputTemplate("validFrom")}/>
                </Col>
                <Col>
                    <Field label={"Valid Until"} body={this.dateInputTemplate("validUntil")}/>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Field label={"Visit Date"} body={this.visitDateTemplate(this.props.referral)}/>
                </Col>
                <Col>
                    <Field label={"Ref No"} body={
                        <Form.Control
                            type="text"
                            placeholder="Reference no"
                            style={{fontSize: '14px'}}
                            value={this.props.referral.referenceNo || ''}
                            disabled={this.props.readOnly}
                            onChange={(e) => this.props.onReferralChange(this.props.referral.id, 'referenceNo', e.target.value)}
                        />
                    }/>
                </Col>
            </Row>
        </Container>
    }
}

class Field extends Component {
    render() {
        const {label, body} = this.props;
        return <div style={{display: 'flex', alignItems: 'center', marginBottom: 8, gap: '10px'}}>
            <div><b>{label}:</b></div>
            <div>{body}</div>
        </div>;
    }
}